import { request } from "@/plugins/axios";

export async function queryCountries(params) {
    return await request({
        url: '/api/com/country',
        method: 'get',
        params: params
    })
}

export async function queryProvinces() {
    return await request({
        url: '/api/com/area',
        method: 'get',
    })
}

export async function queryCities(params) {
    return await request({
        url: '/api/com/country_city',
        method: 'get',
        params: params
    })
}